module.exports = __webpack_public_path__ + "media/images/android2-52d1698ed5a85ae53c4fe4f00027c630.png";